export default __webpack_public_path__ + "static/TD_1_hour_landing_page_hero-f4e1a1bbe656619aa7680603adc3110e.png";